import React from "react";
import AMobileListForm from "./aMobileListForm";
import MobileSystemLogDataForm from "./mobileSystemLogDataForm";
import SystemLogAccess from "../../../services/database/systemLogAccess";
import {systemLogTable} from "../../../config.json";

class MobileSystemLogListForm extends AMobileListForm {
    constructor(props) {
        super(props);
    }

    availableModes = {
        list: true,
        show: true
    };
    tableDefinition = [
        {header: "Name", field: "name"},
        {
            header: "Wert",
            field: "value"
        }
    ];

    getMobileDataForm = () => {
        return <MobileSystemLogDataForm/>;
    };

    loadAllData = async () => {
        let dataList = [];
        const {database} = this.props;
        if (database) {
            this.recordList = await SystemLogAccess.getAll(database, systemLogTable);
            if (this.recordList && this.recordList.length > 0) {
                for (const record of this.recordList) {
                    dataList.push({
                        id: record.id,
                        name: record.name,
                        value: record.value
                    });
                }
            }
        }
        this.setState({dataList});
    };
}

export default MobileSystemLogListForm;
